/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from "react";
import Discuss from "parts/Discuss";
import Button from "elements/Button";
import BenefitsSection from "components/BenefitsSection";

export default function RoboticProcessAutomation() {
  return (
    <>
      {/* FEATURES SECTION */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            What RPA Can Do
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            Replace manual, repetitive tasks with fast, accurate, automated digital workers.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Automate Repetitive Tasks
              </h3>
              <p className="text-surface-300 leading-relaxed">
                From data entry to file transfers, RPA handles routine work automatically.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Reduce Human Error
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Automated workflows ensure accuracy and consistency across your operations.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Boost Productivity
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Let your team focus on strategic tasks — while bots handle the busy work.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION (Reusable) */}
      <BenefitsSection
        title="Why Automate with RPA?"
        subtitle="Robotic Process Automation removes manual effort and delivers consistent, scalable results."
        benefits={[
          {
            id: "lower-costs",
            title: "Lower Operational Costs",
            text: "Automation reduces manual workload, labor costs, and time-consuming tasks.",
            delay: 0,
          },
          {
            id: "accuracy",
            title: "Improve Accuracy",
            text: "Digital workers ensure predictable, consistent, error-free output.",
            delay: 120,
          },
          {
            id: "scale",
            title: "Scale with Ease",
            text: "Deploy more bots instantly as your workflow volume grows.",
            delay: 240,
          },
        ]}
        gainsTitle="What You’ll Gain"
        gains={[
          { id: "efficiency", text: "More efficient operations" },
          { id: "consistency", text: "Consistent and accurate workflows" },
          { id: "overhead", text: "Lower operational overhead" },
          { id: "speed", text: "Faster task completion" },
        ]}
      />

      {/* CTA SECTION */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Ready to automate your business?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              Let us build a custom RPA solution that fits your exact workflow.
            </p>
          </div>

          <Button
            href="/contact"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
